import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {FONTS, WEIGHT} from '../../../shared/style/typography';
import {WHITE, FOCUS_BLUE, CHARCOAL} from '../../../shared/style/colors';
import RequestDemo from './request-demo';
import {PHONE} from '../../../shared/style/breakpoints';
import SimpleButton from '../../../shared/library/buttons/base/simple';
import {ALPHA} from '../../../shared/style/color-utils';

const CtaContainer = glamorous.div(
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 56,
    [PHONE]: {
      flexDirection: 'column'
    }
  },
  ({extraStyle}) => (extraStyle ? extraStyle : {})
);

const SignUpButton = glamorous(SimpleButton)({
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  height: 58,
  fontSize: 20,
  fontWeight: WEIGHT.ULTRA_BOLD,
  background: WHITE,
  color: FOCUS_BLUE,
  borderRadius: 4,
  padding: '0 41px',
  marginRight: 66,
  letterSpacing: 0,
  '&:hover': {
    borderColor: WHITE
  },
  [PHONE]: {
    width: '98%',
    margin: 0,
    padding: 0,
    marginBottom: 23
  }
}).withComponent('a');

const Cta = ({extraStyle}) => {
  return (
    <CtaContainer extraStyle={extraStyle}>
      <SignUpButton href="/manage-companies/enterprise" title="Sign up" target="_blank">
        Sign up for Free
      </SignUpButton>
      <RequestDemo
        eventProperties={{
          index: 1,
          sectionName: 'CTA'
        }}
        extraStyle={{
          color: WHITE,
          background: CHARCOAL,
          fontFamily: FONTS.CEREBRI_SANS_PRO,
          fontSize: 20,
          fontWeight: WEIGHT.ULTRA_BOLD,
          height: 58,
          padding: '0 41px',
          border: `1px solid ${WHITE}`,
          borderRadius: 4,
          minWidth: 'auto',
          ':hover': {
            border: `1px solid ${WHITE}`,
            backgroundColor: ALPHA(CHARCOAL, 0.8)
          }
        }}
      />
    </CtaContainer>
  );
};

Cta.propTypes = {
  extraStyle: PropTypes.object
};

export default Cta;
